<template>
<b-row>
   <b-navbar fixed=top toggleable="md">
     <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
     <b-collapse id="nav-collapse" is-nav>
       <b-nav align="left">
          <a href='/'>Home</a>
          <a href='/about'>About</a>
          <a href='/issues'>Issues</a>
          <a href='/order'>Order</a>
          <a href='/opencall'>Contribute</a>

        </b-nav>
      </b-collapse>
   </b-navbar>
</b-row>
</template>

<script>
export default {
  name: 'MenuBar',
}

</script>

<style scoped>

a {
  color: #333042;
  font-family: 'Poppins', sans-serif;;
  font-size: 16px;
  padding: 10px;
}

a:hover {
  color: #ff4c2b;

}

.navbar {
  background-color: #C4C4C4;
}

@media (max-width: 575px) {
  a {
    font-size: 12px;

  }
  .navbar {
    border-bottom: 0px;
  }
}
</style>
